import type {
  AttachUploadLinkHandlers,
  AttachUploadLinkToolConfig,
} from './editorjs-attach-upload-link-tool';
import type { API } from '@editorjs/editorjs';

type SelectionWithExtras = API['selection'] & {
  collapseToEnd?: () => void;
  clearSaved?: () => void;
  isFakeBackgroundEnabled?: boolean;
};

/**
 * Opens the attach-upload modal after validation (used by the inline tool and the slash menu).
 * Caller must ensure selection is non-collapsed and not already inside a link.
 */
export function executeAttachUploadLinkModal(
  api: Pick<API, 'selection' | 'inlineToolbar'>,
  config: AttachUploadLinkToolConfig,
): void {
  const request = config.onRequestAttachUploadLink;
  if (!request) {
    return;
  }

  api.selection.setFakeBackground();
  api.selection.save();

  const selection = api.selection as SelectionWithExtras;

  const applyHref: AttachUploadLinkHandlers['applyHref'] = (href: string) => {
    api.selection.restore();
    api.selection.removeFakeBackground();
    document.execCommand('createLink', false, href);
    selection.collapseToEnd?.();
    selection.clearSaved?.();
    api.inlineToolbar.close();
  };

  const cancel: AttachUploadLinkHandlers['cancel'] = () => {
    if (selection.isFakeBackgroundEnabled) {
      api.selection.restore();
      api.selection.removeFakeBackground();
    }

    selection.clearSaved?.();
    api.inlineToolbar.close();
  };

  request({ applyHref, cancel });
}
